import { CommonQuestionModel } from 'src/app/model/common/question';
import { CommonQuestionViewModel } from 'src/app/model/common/question.view';

export interface CommonQuestionState {
  adminResult: CommonQuestionModel[];
  consultTopQuestions: CommonQuestionViewModel[];
  consultBottomQuestions: CommonQuestionViewModel[];
}

export const commonQuestionIS: CommonQuestionState = {
  adminResult: [],
  consultTopQuestions: [],
  consultBottomQuestions: [],
};
